import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';

import { Helmet } from 'react-helmet-async';

function App() {
  const content = useRoutes(router);
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Helmet>
          <style>{`
            body {
              background: rgb(255,255,255);
              background: linear-gradient(18deg, rgba(255,255,255,1) 0%, rgba(233,252,255,1) 58%, rgba(255,248,223,1) 100%);
              background-size: cover;
              object-fit: cover;
              background-attachment: fixed;

            }
          `}</style>
        </Helmet>
        <CssBaseline />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
